import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';

interface RequireRoleProps {
  allowed: string[];
}

const RequireRole: React.FC<RequireRoleProps> = ({ allowed }) => {
  const { user, isAuthenticated, authReady } = useAuth();
  const location = useLocation();
  const normalizedUserRole = user?.role === 'receptionist' ? 'reception' : user?.role;
  const normalizedAllowedRoles = allowed.map((role) => role === 'receptionist' ? 'reception' : role);
  
  // Așteaptă ca autentificarea să fie inițializată
  if (!authReady) {
    return <div>Loading...</div>;
  }
  
  if (!isAuthenticated || !user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  if (!normalizedAllowedRoles.includes(normalizedUserRole || '')) {
    // Redirectioneaza spre dashboard-ul rolului curent daca exista
    if (normalizedUserRole === 'master_admin') {
      return <Navigate to="/master-admin" replace />;
    }
    if (normalizedUserRole === 'clinic_admin') {
      return <Navigate to="/clinic" replace />;
    }
    if (normalizedUserRole === 'veterinarian' || normalizedUserRole === 'doctor') {
      return <Navigate to="/doctor" replace />;
    }
    if (normalizedUserRole === 'reception') {
      return <Navigate to="/receptie" replace />;
    }
    if (normalizedUserRole === 'shelter_admin' || normalizedUserRole === 'shelter_staff') {
      return <Navigate to="/shelter" replace />;
    }
    // Implicit (client sau rol necunoscut)
    return <Navigate to="/dashboard" replace />;
  }
  
  return <Outlet />;
};

export default RequireRole;
